module.exports = __webpack_public_path__ + "img/footer-logo.93c17ae3.png";